import logo from './logo.svg';
import './App.css';
import News from './news'

function App() {
  return (
    <div className="App">
     <News />
    </div>
  );
}

export default App;
